import React from 'react';
import './PostControlInfoDetail.scss';
import '../CreatePostControlInfoAbbrevs/CreatePostControlInfoAbbrevs.scss';
import {DocumentOnList} from '../documents';
import {mapNewAttachments, mapNewFindings, mapOrders, mapPaymentClaims, sortAttachmentsByOrderIndex} from '../documents/helpers';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import {ControlDetailInfo} from '../ControlDetailInfo/ControlDetailInfo';
import * as httpService from '../HttpService/HttpService';
import {sendLog} from '../HttpService/SendLog';
import FinancialTable from '../FInancialTable/FinancialTable';
import {PDFDownloadLink} from '@react-pdf/renderer';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PdfInfo from '../PdfPostControl/PdfPostControlInfo';
import {Waiter} from '.././WaitingSign/Waiting';
import { isWTrakcieRealizacji,numberFindingsByBlock,getUniqueBlocks} from "../ControlStateHelper";
import PopUp from "../PopUp/PopUp";
import {errorMessageText} from "../HttpService/HttpService";
import {AuditDetail} from "../AuditDetail/AuditDetail";
import {draftjsToHTML} from '../WysiwygEditor/WysiwygHelpers';


export const GET_CONTROL_LIST_DATA_REQUESTED = 'GET_CONTROL_LIST_DATA_REQUESTED';
export const GET_CONTROL_LIST_DATA_DONE = 'GET_CONTROL_LIST_DATA_DONE';
export const GET_CONTROL_LIST_DATA_FAILED = 'GET_CONTROL_LIST_DATA_FAILED';

export const createPdf = (isDraft, state, infoNumber, checklistVersion) => {
	return (
		<PdfInfo
			control={state.controlData}
			checklistVersionInfo = {checklistVersion}
			infoNumber={infoNumber}
			infoData={state.infoData}
			abbrevs={state.infoData.abbreviations}
			isDraft={isDraft}
		/>
	)
};


class PostControlInfoDetail extends React.Component {

	infoId;
	controlId;
	infoNumber;

	constructor(props) {
		super(props);
		this.state = {
			isLocked: true,
			isWaiting: true,
			infoData: null,
			controlData: null,
			checklistVersionInfo: 'Wersja 1',
			expandedFindings: [],
			showPopup: false,
			popUp: []
		};

		this.handleExpandFinding = this.handleExpandFinding.bind(this);
		this.handleShrinkFinding = this.handleShrinkFinding.bind(this);
		this.handleClosePopUp = this.handleClosePopUp.bind(this);

	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	componentDidMount() {
		this.infoId = this.props.match.params.infoId;
		this.controlId = this.props.match.params.controlId;
		this.fetchControlInfoData(this.controlId, this.props.source);
	}

	fetchControlInfoData = (controlId, source) => {
		const url = source === "my_controls" ? PropertyBucket.getMyControlDetailByControlId(controlId) : PropertyBucket.getPostControlDetailByControlId(controlId);
		let response = httpService.getService(url, 'GET');
		response.then(
			data => {
				let postControlDocument = data.postControlDocuments.find(el => el.postControlInfo && el.postControlInfo.id == this.infoId)?.postControlInfo
				if(postControlDocument) {
					mapPaymentClaims(data, postControlDocument.findings)
					mapOrders(data, postControlDocument.findings)
					mapNewFindings(postControlDocument, data)
					let attachmentsMap = mapNewAttachments(postControlDocument, data)
					this.setState({
						infoData: postControlDocument,
						attachments: attachmentsMap,
						controlData: data,
						checklistVersionInfo: postControlDocument.checklistVersion || 'Wersja 1',
						isWaiting: false
					})
				} else {
					let unauthorized = errorMessageText(401)
					throw Error(unauthorized);
				}
			})
			.catch(error => {
				this.setState({
					showPopup: true,
					popUp: {title: 'Błąd', notification: error.message, type: 'error'},
					isWaiting: false
				})
			});
	};
	goBack = () => {
		this.props.history.goBack();
	};

	isNotDraft = (control, infoData) => {
		const isCompleateDate = infoData?.isFinalInfo ? infoData?.finalInfoSendDate : infoData?.receivedByControlledEntityDate;

		return (isWTrakcieRealizacji(control) && isCompleateDate) || !isWTrakcieRealizacji(control)
	};


	printContent = (control) => {
		let fileName = 'eKontrole-' + this.infoNumber + '.pdf';
		let infoData = this.state.infoData;
		document.title = `e-Kontrole | ${infoData?.isFinalInfo ? 'Ostateczna i' : 'I'}nformacja pokontrolna nr: ${this.infoNumber || ''}, numer kontroli: ${control.number}`;
		const isDraft = !this.isNotDraft(control, infoData);

		return <div>
			<button className='btn success-btn' id='pdf_img_container' onClick={() => { sendLog(null, null, fileName) }}>
				<span className="sr-only">Pobierz PDF</span>
				<PDFDownloadLink document={createPdf(isDraft, this.state, this.infoNumber, this.state.checklistVersionInfo)} fileName={fileName}>
					{({ loading }) => (loading ? '' : (
						<>
							<PictureAsPdfIcon style={{ color: '#0d47a1', fontSize: 46 }} />
							<span className="sr-only">Kliknij, aby pobrać PDF</span>
						</>
					))}
				</PDFDownloadLink>
			</button>
			{isDraft && <span className='red h5'>WERSJA ROBOCZA</span>}
			<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
			                                                                                  aria-hidden='true'
			                                                                                  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
			</button>
			<br/>


			<h3 align='center'><span className='titleClass'>{infoData?.isFinalInfo ? 'OSTATECZNA ' : ''}INFORMACJA POKONTROLNA nr</span>&nbsp;&nbsp;&nbsp;
				<span>{this.infoNumber || ''}</span><br/>
				<span className='titleClass'>Numer kontroli</span><span>{control.number}</span></h3>

			<div className="framed-part framed-part--first">
				<h4 className="framed-part__title">Informacje wstępne</h4>
				<ControlDetailInfo control={control} checklistVersionInfo={this.state.checklistVersionInfo} />
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">1. Wykaz skrótów</h4>
				{this.renderAbbreviations()}
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">2. Podstawa prawna</h4>
				<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(infoData.legalBasis) }} />
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">3. Cel kontroli</h4>
				<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(infoData.controlPurpose) }} />
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">4. Przedmiot kontroli</h4>
				<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(infoData.controlSubject) }} />
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">5. Ustalenia i zalecenia pokontrolne</h4>
				{this.renderBlocks()}
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">6. Podsumowanie ustaleń finansowych</h4>
				{this.renderFinancialTable()}
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">7. Podsumowanie kontroli</h4>
				<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(infoData.controlSummary) }} />
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">8. Pouczenie końcowe</h4>
				<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(infoData.finalInstructions) }} />
			</div>

			<div className="framed-part">
				<h4 className="framed-part__title">9. Załączniki</h4>
				{this.renderAttachments()}
			</div>

			<div style={{borderTop: '2px solid'}}>
				<h4 className='mt-4'>Dane audytowe:</h4>
				{<AuditDetail 
					auditData={{
						createdOn: infoData?.dataCreatedOn,
						createdByLogin: infoData?.dataCreatedByLogin,
						createdBy: infoData?.dataCreatedBy,
						updatedOn: infoData?.dataUpdatedOn,
						updatedByLogin: infoData?.dataUpdatedByLogin,
						updatedBy: infoData?.dataUpdatedBy,
					}}>
				</AuditDetail>}
			</div>
		</div>;
	};

	renderAbbreviations = () => {
		let abbrevs = this.state.infoData.abbreviations || "";
		if (!abbrevs) {
			return
		}
		const htmlContent = abbrevs.replace(/\n/g, '<br>');
		return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
	};


	// obsługa ustaleń i zaleceń
	renderBlocks() {
		const CHAPTER = '5.';
		const numberedFindings = numberFindingsByBlock(this.state.infoData.findings);
		if (numberedFindings.length === 0) {
			return 'Brak.'
		}
		const blocks = getUniqueBlocks(numberedFindings);

		return blocks.map((block, idx) => {
			const blockNumber = idx + 1;
			const findingsInBlock = numberedFindings.filter(f => f.blockInList.id === block.id);

			return (
				<div key={block.id}>
					<h4 className='my-5'>{`${CHAPTER}${blockNumber} ${block.name}`}</h4>
					{this.renderFindings(findingsInBlock)}
				</div>
			);
		});
	}

	isFinancial(finding) {
		return finding.corrections.length > 0;
	}

	handleExpandFinding(findingId) {
		this.setState({
			expandedFindings: [...this.state.expandedFindings, findingId]
		});
	}

	handleShrinkFinding(findingId) {
		this.setState({
			expandedFindings: [...this.state.expandedFindings.filter(fid => fid !== findingId)]
		});
	}

	renderFindings(findingsInBlock) {
		const CHAPTER = 'Ustalenie nr ';
		return findingsInBlock.map(finding => {
			const isExpanded = this.state.expandedFindings.includes(finding.id);
			const isFinancial = this.isFinancial(finding);
			const handleFunction = isExpanded ? this.handleShrinkFinding : this.handleExpandFinding;

			const expandedPart = (
				<div>
					{isFinancial && finding.findingKind && (<p><b>Typ ustalenia finansowego: </b>{`${finding.findingKind.code} ${finding.findingKind.name}`}</p>)}
					<p>
						<b>Szczegóły ustalenia:</b>
						<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(finding.content) }} />
					</p>
					{finding.recommendations.length > 0 && (
						<>
							<h6 className='font-weight-bold my-4'>{`Zalecenia związane z ustaleniem nr ${finding.number}`}</h6>
							{this.renderRecommendations(finding)}
						</>
					)}
				</div>
			);

			return (
				<div key={finding.id}>
					<button className='invisibleButton' onClick={() => handleFunction(finding.id)}>
						<h5 className='my-4' style={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
							<div style={{ display: 'inline-block' }}>
								{`${CHAPTER} ${finding.number} ${isFinancial ? '(finansowe)' : ''}: `}
								<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(finding.title) }} />
							</div>
							<div style={{ display: 'inline-block' }}>
								{isExpanded	? <ExpandLess fontSize='large' style={{ float: 'right' }} /> : <ExpandMore fontSize='large' style={{ float: 'right' }} />}
							</div>
						</h5>
					</button>
					{isExpanded && expandedPart}
				</div>
			);
		});
	}

	renderRecommendations(finding) {
		return finding.recommendations.map((r, i) => {
			return (<div key={r.recommendationId} className='my-3 pl-4'>
						<p className='font-weight-bold'>{`Zalecenie ${finding.number}.${i + 1}`}</p>
						<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(r.recommendationText) }} />
					</div>)
		});
	}

	renderFinancialTable() {
		const numberedFindings = numberFindingsByBlock(this.state.infoData.findings);
		if (numberedFindings.some(f => f.corrections.length > 0)) {
			return (
				<>
					<FinancialTable infoData={{ ...this.state.infoData, findings: numberedFindings }} />
					{this.state.infoData.financialFindingsNotes && (
						<div className="mt-3">
							<p><strong>Uwagi do ustaleń finansowych:</strong></p>
							<div dangerouslySetInnerHTML={{ __html: draftjsToHTML(this.state.infoData.financialFindingsNotes) }} />
						</div>
					)}
				</>
			);
		} else {
			return 'Brak ustaleń finansowych.'
		}
	}

	renderAttachments() {
		if (!this.state.attachments?.length) {
			return
		}

		return (this.state.attachments || [])
			.sort(sortAttachmentsByOrderIndex)
			.map((attachment, index) => (
				<DocumentOnList
					document={attachment.document}
					key={attachment.id}
					index={index + 1}
					withIndexOnList
				/>
			))
	}

	render() {

		let control = this.state.controlData;


		let popUp;
			popUp = <PopUp
				type={this.state.popUp.type}
				title={this.state.popUp.title}
				notification={this.state.popUp.notification}
				closePopUp={this.handleClosePopUp}
			/>;

		if (this.state.controlData && this.state.infoData) {
			let isFinal = this.state.infoData.isFinalInfo;
			let infoSuffix = isFinal ? '-OST' : '-INF';
			this.infoNumber = this.state.controlData.number + infoSuffix;
		}

		return (
			<div id='post-control-info'>
				{control ? this.printContent(control) : <button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
																																		  aria-hidden='true'
																																		  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
				</button>}
				<div id='waiter'><Waiter loading={this.state.isWaiting}/></div>
				{this.state.showPopup ? popUp : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		//fetchControlData: url => dispatch(actions.getControlData(url))
	}
};
export const PostControlInfoDetailProvider = connect(mapStateToProps, mapDispatchToProps)(PostControlInfoDetail);



